module.exports = __webpack_public_path__ + "media/images/background_graphics/publication_graphic_mobile-6f1baea6b52e2bea5d5bf2a700bd1bde.svg";